import React, { useState } from "react";
import { sendData } from "../../Config/FirebaseMethod";
import { CircularProgress, FormHelperText } from "@mui/material";

const ProjectsForm = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [msg, setMsg] = useState("");
  const [errormsg, setErrormsg] = useState("");

  const [projectTitle, setProjectname] = useState("");
  const [projectLink, setProjectlink] = useState("");
  const [projectSub, setProjectSub] = useState("");
  const [projectImg1, setProjectImg1] = useState("");
  const [projectImg2, setProjectImg2] = useState("");
  const [projectImg3, setProjectImg3] = useState("");
  const [projectImg4, setProjectImg4] = useState("");
  const [projectDesc, setProjectDesc] = useState("");
  const [projectKey1, setProjectkey1] = useState("");
  const [projectKey2, setProjectkey2] = useState("");
  const [projectKey3, setProjectkey3] = useState("");
  const [projectKey4, setProjectkey4] = useState("");
  const [projectKey5, setProjectkey5] = useState("");
  const [projectKey6, setProjectkey6] = useState("");
  const [projectKey7, setProjectkey7] = useState("");
  const [projectWebLink, setProjectWebLink] = useState("");

  let signUp = () => {
    setIsLoading(true);
    sendData(
      {
        projectTitle,
        projectLink,
        projectSub,
        projectImg1,
        projectImg2,
        projectImg3,
        projectImg4,
        projectDesc,
        projectKey1,
        projectKey2,
        projectKey3,
        projectKey4,
        projectKey5,
        projectKey6,
        projectKey7,
        projectWebLink,
      },
      "Projects"
    )
      .then((success) => {
        setIsLoading(false);
        setMsg(success);
      })
      .catch((error) => {
        setError(true);
        setIsLoading(false);
        setErrormsg(error);
      });
  };

  let handleSubmit = (e) => {
    e.preventDefault();
    signUp();
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="container mt-5">
          <div className="row">
            <div className="col-lg-6">
              <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label">
                  Project Name
                </label>
                <input
                  style={{ color: "white", backgroundColor: "#383838" }}
                  type="text"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  onChange={(e) => setProjectname(e.target.value)}
                />
              </div>
              <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label">
                  Project Sub Heading
                </label>
                <input
                  style={{ color: "white", backgroundColor: "#383838" }}
                  type="text"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  onChange={(e) => setProjectSub(e.target.value)}
                />
              </div>
              <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label">
                  Project Image 2
                </label>
                <input
                  style={{ color: "white", backgroundColor: "#383838" }}
                  type="text"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  onChange={(e) => setProjectImg2(e.target.value)}
                />
              </div>
              <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label">
                  Project Image 4
                </label>
                <input
                  style={{ color: "white", backgroundColor: "#383838" }}
                  type="text"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  onChange={(e) => setProjectImg4(e.target.value)}
                />
              </div>
              <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label">
                  Key Feature 1
                </label>
                <input
                  style={{ color: "white", backgroundColor: "#383838" }}
                  type="text"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  onChange={(e) => setProjectkey1(e.target.value)}
                />
              </div>
              <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label">
                  Key Feature 3
                </label>
                <input
                  style={{ color: "white", backgroundColor: "#383838" }}
                  type="text"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  onChange={(e) => setProjectkey3(e.target.value)}
                />
              </div>
              <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label">
                  Key Feature 5
                </label>
                <input
                  style={{ color: "white", backgroundColor: "#383838" }}
                  type="text"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  onChange={(e) => setProjectkey5(e.target.value)}
                />
              </div>
              <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label">
                  Key Feature 7
                </label>
                <input
                  style={{ color: "white", backgroundColor: "#383838" }}
                  type="text"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  onChange={(e) => setProjectkey7(e.target.value)}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label">
                  Project Link
                </label>
                <input
                  style={{ color: "white", backgroundColor: "#383838" }}
                  type="text"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  onChange={(e) => setProjectlink(e.target.value)}
                />
              </div>
              <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label">
                  Project Image 1
                </label>
                <input
                  style={{ color: "white", backgroundColor: "#383838" }}
                  type="text"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  onChange={(e) => setProjectImg1(e.target.value)}
                />
              </div>
              <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label">
                  Project Image 3
                </label>
                <input
                  style={{ color: "white", backgroundColor: "#383838" }}
                  type="text"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  onChange={(e) => setProjectImg3(e.target.value)}
                />
              </div>
              <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label">
                  Project Web Link
                </label>
                <input
                  style={{ color: "white", backgroundColor: "#383838" }}
                  type="text"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  onChange={(e) => setProjectWebLink(e.target.value)}
                />
              </div>
              <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label">
                  Key Feature 2
                </label>
                <input
                  style={{ color: "white", backgroundColor: "#383838" }}
                  type="text"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  onChange={(e) => setProjectkey2(e.target.value)}
                />
              </div>
              <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label">
                  Key Feature 4
                </label>
                <input
                  style={{ color: "white", backgroundColor: "#383838" }}
                  type="text"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  onChange={(e) => setProjectkey4(e.target.value)}
                />
              </div>
              <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label">
                  Key Feature 6
                </label>
                <input
                  style={{ color: "white", backgroundColor: "#383838" }}
                  type="text"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  onChange={(e) => setProjectkey6(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div class="mb-3">
            <label for="exampleFormControlTextarea1" class="form-label">
              Project Description
            </label>
            <textarea
              style={{ color: "white", backgroundColor: "#383838" }}
              class="form-control"
              id="exampleFormControlTextarea1"
              rows="3"
              onChange={(e) => setProjectDesc(e.target.value)}
            ></textarea>
          </div>
          <button type="submit" class="btn btn-primary">
            {isLoading ? <CircularProgress /> : "Submit"}
          </button>
        </div>
      </form>
      <FormHelperText
        id="component-error-text"
        sx={{ color: "green", fontSize: 16 }}
        className="text-center"
      >
        {msg}
      </FormHelperText>
      <FormHelperText
        id="component-error-text"
        sx={{ color: "red", fontSize: 16 }}
        className="text-center"
      >
        {errormsg}
      </FormHelperText>
    </div>
  );
};

export default ProjectsForm;
